import { createContext,useEffect, useState } from "react";
import { auth } from "../config/firebase";
import { onAuthStateChanged } from "firebase/auth";

export const AuthContext = createContext();

export const AuthContextProvider = ( {children}) =>{
    // const [displayname, setdisplayname] = useState("")
    const [isactive, setisactive] = useState(false)
    const [currentuser, setcurrentuser] = useState({})
    useEffect(()=>{
      const unsub = onAuthStateChanged(auth, (user) => {
  
        //   const uid = user.uid;
          setcurrentuser(user)
          console.log(user)
        //   setdisplayname(user.displayName)
        if(user){
          setisactive(true)
        }
        else{
            setisactive(false)
        }
      });

      return () =>{
        unsub();
      };

    },[]);

    return(
  <AuthContext.Provider value={{currentuser, isactive}}>
    {children}
  </AuthContext.Provider>
    );
};